import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import './newVisitModal.scss'
import { useEffect, useState } from 'react';
import { Card, DialogActions, Divider, TextField, } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import AddHomeRoundedIcon from '@mui/icons-material/AddHomeRounded';
import { useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../../../../store/hooks/hooks';
import { StudentActions } from '../../../../store/StudentAction';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import AdminApi from '../../../../store/services/admin';
import { getEvents } from '../../../../store/adminActions';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CardContent from '@mui/material/CardContent';
import ExploreRoundedIcon from '@mui/icons-material/ExploreRounded';
import FmdGoodRoundedIcon from '@mui/icons-material/FmdGoodRounded';
import Avatar from '../../../../utils/Avatar/Avatar';
import PushPinRoundedIcon from '@mui/icons-material/PushPinRounded';
import map from "../../../../assets/map.jpg"
import { createNotifictions } from '../../../../utils/helperFunction';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const NewPlacementVisitModal: React.FC<{ path: any, placementList: any,planAgain:any }> = ({ path, placementList,planAgain }) => {
    const [open, setOpen] = React.useState(false)
    const [eventName, setEventName] = useState("")
    const [googleMapUrl, setGoogleMapUrl] = useState("")
    const userDetails = useAppSelector((state: any) => state.user.user)
    const [origin, setOrigin] = React.useState("University Rd, Leicester LE1 7RH");
    const [destination, setDestination] = React.useState("");
    const [scheduleDate, setScheduleDate] = React.useState<Dayjs | null>(
        dayjs(new Date()),
    );
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setIsLoading(false)
        setOpen(false);
    };
    const reset = () => {
        setScheduleDate(dayjs(new Date()))
        setGoogleMapUrl("")
        setEventName("")
    }
    const handleSubmit = async (e: any) => {
        setIsLoading(true)
        e.preventDefault()
        // const editEvent = Object.keys(eventContext.editEvent) && eventContext.editEvent as any
        let participants: any[] = []
        path.path.map((id: any) => {
            if (placementList.filter((elm: any, index: any) => elm.placement.Id == id && id !== 'UOL').length > 0) {
                participants.push(placementList.filter((elm: any, index: any) => elm.placement.Id == id && id !== 'UOL')[0])
            }
        })
        let body = {
            EventType: "PV",
            userId: userDetails.result.Id,
            details: {
                dateApplied: new Date(),
                scheduleDate: scheduleDate,
                destination: destination,
                origin: origin,
                meetingUrl: googleMapUrl,
                title: "Placement Visit",
                participants: [{
                    user: { ...userDetails.result },
                    placement: {
                        CompanyName: "University Rd, Leicester",
                        RegAddressPostCode: "LE1 7RH"
                    }
                }, ...participants],
                rejectedParticipants: [],
                acceptedParticipants: [userDetails.result.Id]
            }
        }
        AdminApi.newEventRequest(body).then(async res => {
            dispatch(StudentActions.setMessage("Visit Generated"))
            participants.forEach((elm: any) => {
                if (elm.user.first_name !== "University") {
                    createNotifictions({
                        target: elm.user.Student_ID,
                        message: `${eventName} visit was scheduled by ${userDetails.result.first_name} ${userDetails.result.last_name} `,
                        type: "PV",
                        eventId: res.data._id
                    })
                }

            })
            await dispatch(getEvents("PV"))
            setIsLoading(false)
            planAgain()
        }).catch((e) => {
            if (e.response.status === 403) {
                navigate('/login')
            }
            setIsLoading(false)
            reset()
            dispatch(StudentActions.setMessage("Request Generation Failed.Try again."))
        })
    }
    useEffect(() => {
        reset()
        handleClose()
    }, [isLoading])

    useEffect(() => {
        let destinationPlacementId = path.path[path.path.length - 1]
        let destinationPlacement = placementList.filter((elm: any) => elm.placement.Id === destinationPlacementId)[0]
        setDestination(`${destinationPlacement.placement.CompanyName} ${destinationPlacement.placement.RegAddressPostCode}`)
    }, [path, placementList])
    return (
        <div>
            <Button variant="contained" className='mx-2' onClick={handleClickOpen} startIcon={<AddRoundedIcon />}>
                Schedule your Visit
            </Button>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                className='w-100'
                keepMounted
                fullWidth
                maxWidth="md"
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Schedule Placement Visit</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit}>
                        <div>
                            <div className='flex flex-column'>
                                <div className='flex justify-content-between m-2'>
                                    <div className='mx-2 w-100'>
                                        <label className='required'>Origin :</label>
                                        <input value={origin} disabled onChange={(e) => {
                                            setOrigin('University Rd, Leicester LE1 7RH')
                                        }}></input>
                                    </div>
                                    <div className='w-100'>
                                        <label className='required'>Destination :</label>
                                        <input value={destination} disabled onChange={(e) => {
                                        }}></input>
                                    </div>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <label className='required'>Route Path:</label>
                                    <div className='m-1 flex routeScrollContainer flex-row'>
                                        <Card className='routeCard m-2 originContainer'>
                                            <CardContent className='flex align-items-center'>
                                                <div className='routeIconContainer align-items-center flex justify-content-center m-2'>
                                                    <img src={map} style={{ height: "80px", borderRadius: "4px" }}></img>
                                                    {/* <ExploreRoundedIcon className='gray-color' fontSize='small'></ExploreRoundedIcon> */}
                                                </div>
                                                <div className='m-1'>
                                                    <div className='flex p-1'>
                                                        <PushPinRoundedIcon className='gray-color' fontSize='small'></PushPinRoundedIcon>
                                                        <p className='routeCardText m-0 mx-1'>University Rd, Leicester</p>
                                                    </div>
                                                    <div className='flex p-1'>
                                                        <FmdGoodRoundedIcon className='gray-color' fontSize='small'></FmdGoodRoundedIcon>
                                                        <p className='routeCardText m-0 mx-1'>LE1 7RH</p>
                                                    </div>
                                                    <div className='flex p-1'>
                                                        <Avatar name={"University Leicester"}></Avatar>
                                                        <p className='routeCardText m-0 mx-1'>University of Leicester</p>
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </Card>
                                        <div className='align-items-center flex justify-content-center dividerContainer'>
                                            <Divider className='dividerWidth' />
                                        </div>
                                        {
                                            path.path && path.path.map((id: any, index: any) => {
                                                if (placementList.filter((elm: any, index: any) => elm.placement.Id == id && id !== 'UOL').length > 0) {
                                                    let placementDetails = placementList.filter((elm: any, index: any) => elm.placement.Id == id && id !== 'UOL')[0]
                                                    return (
                                                        <div key={index} className="flex">
                                                            <Card className={index !== path.path.length - 1 ? 'routeCard m-2' : index === 0 ? 'originContainer routeCard m-2':'destinationContainer routeCard m-2'}>
                                                                <CardContent className='flex align-items-center p-2'>
                                                                    <div className='routeIconContainer align-items-center flex justify-content-center m-2 p-2'>
                                                                        <img src={map} style={{ height: "80px", borderRadius: "4px" }}></img>
                                                                        {/* <ExploreRoundedIcon className='gray-color' fontSize='small'></ExploreRoundedIcon> */}
                                                                    </div>
                                                                    <div className='m-1'>
                                                                        <div className='flex p-1'>
                                                                            <PushPinRoundedIcon className='gray-color' fontSize='small'></PushPinRoundedIcon>
                                                                            <p className='routeCardText m-0 mx-1'>{placementDetails.placement.CompanyName}</p>
                                                                        </div>
                                                                        <div className='flex p-1'>
                                                                            <FmdGoodRoundedIcon className='gray-color' fontSize='small'></FmdGoodRoundedIcon>
                                                                            <p className='routeCardText m-0 mx-1'>{placementDetails.placement.RegAddressPostCode}</p>
                                                                        </div>
                                                                        <div className='flex p-1'>
                                                                            <Avatar name={`${placementDetails.user.first_name} ${placementDetails.user.last_name}`}></Avatar>
                                                                            <p className='routeCardText m-0 mx-1'>{`${placementDetails.user.first_name} ${placementDetails.user.last_name}`}</p>
                                                                        </div>
                                                                    </div>
                                                                </CardContent>
                                                            </Card>
                                                            {
                                                                index !== path.path.length - 1 && <div className='align-items-center flex justify-content-center dividerContainer'>
                                                                    <Divider className='dividerWidth' />
                                                                </div>
                                                            }

                                                        </div>
                                                    )
                                                }

                                            })
                                        }
                                    </div>
                                </div>
                                <div className='flex justify-content-between'>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <div className='flex flex-column m-2 w-50'>
                                            <label className='required'>Schedule Date:</label>
                                            <DatePicker
                                                value={scheduleDate}
                                                minDate={dayjs(new Date())}
                                                onChange={(newValue: Dayjs | null) => {
                                                    setScheduleDate(newValue)
                                                }}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                        </div>
                                    </LocalizationProvider>
                                </div>
                                <div className='flex flex-column m-2'>
                                    <label >Google Map URL:</label>
                                    <input value={googleMapUrl} disabled onChange={(e) => {
                                        setGoogleMapUrl(e.target.value)
                                    }}></input>
                                </div>
                            </div>
                        </div>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <LoadingButton
                        loading={isLoading}
                        loadingPosition="start"
                        onClick={handleSubmit}
                        startIcon={<AddHomeRoundedIcon />}
                        variant="contained"
                        autoFocus
                    >
                        Schedule Visit
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default NewPlacementVisitModal;